<template>
  <div>
    <div class="teacher-list">
      <Teacher
        class="teacher"
        v-for="it in teachers"
        :key="it.id"
        :teacher="it"
        :onPressed="openModal(it)"
      />
    </div>
    <TeacherModal
      v-if="teacher != null"
      :teacher="teacher"
      :onDismiss="onModalDismiss"
    />
  </div>
</template>

<script>
import Teacher from "@/components/Teacher.vue";
import TeacherModal from "@/components/TeacherModal.vue";

export default {
  components: {
    Teacher,
    TeacherModal
  },
  props: {
    teachers: Array
  },
  data() {
    return {
      teacher: null
    };
  },
  methods: {
    openModal(teacher) {
      return () => {
        this.teacher = teacher;
      };
    },
    onModalDismiss() {
      this.teacher = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.teacher-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px;
  margin: 0 10px;
}

@media (max-width: 480px) {
  .teacher-list {
    grid-template-columns: 1fr 1fr !important;
    margin: 0 40px;
  }
}
</style>
